import { Box } from 'grommet';

export const List = props => <Box fill pad="none" tag="ul" border="top" {...props} />;
export const ListItem = props => (
  <Box tag="li" border="bottom" pad="small" direction="row" justify="between" {...props} />
);
